import React, {Component} from 'react';
import {
    Dimensions,
    Image,
    View,
    I18nManager,
    StatusBar,
    Text,
    StyleSheet,
    AppState,
    TouchableOpacity, Modal, TextInput, TouchableWithoutFeedback, Alert
} from 'react-native';
import {connect} from "react-redux";

import HttpRequest from "../utils/HttpRequest";
import AppButton from "./AppButton";
import AppText from "./AppText";
import ISubOrder from "../Models/Courier/ISubOrder";
import IOrder from "../Models/IOrder";
import {EOrderStatus} from "../Models/EOrderStatus";
import IAppState from "../Models/App/IAppState";
import {saveOpenedOrders} from "../Models/Courier/CourierActions";
import {AnyAction} from "redux";


interface IProps {
    show:boolean;
    text:string;
    confirmCallBack:Function;
    closeCallBack:Function;

}
interface IState {

}
const width=Dimensions.get('window').width;
export default class ConfirmionModal extends Component< IProps > {
    state:IState={
    }
    componentDidMount(): void {

    }

    render() {

        return(
            <Modal
                animationType="fade"
                transparent={true }
                visible={ this.props.show ? true : false}

                onRequestClose={() => {

                }}
            >
                <View style={{width:'100%',height:'100%',backgroundColor:'rgba(0,0,0,0.5)',justifyContent:'center',alignItems:'center'}}>
                    <View style={{width:'90%',height:200,backgroundColor:'white',paddingLeft:15,paddingRight:15}}>
                        <View style={{width:'100%',height:150,justifyContent:'center',alignItems:'center'}}>
                            <AppText style={{fontWeight:'500',fontSize:16}}>{this.props.text}</AppText>
                        </View>

                        <View style={{width:'100%',flexDirection:'row',justifyContent:'space-around'}}>
                            <TouchableOpacity onPress={()=>this.props.closeCallBack()} style={{width:'40%',height:35,backgroundColor:'#019FB2',borderRadius:5,justifyContent:'center',alignItems:'center'}}>
                                <AppText style={{fontSize:16,fontWeight:'500',color:'black'}}>ביטול</AppText>
                            </TouchableOpacity>
                            <TouchableOpacity onPress={()=>this.props.confirmCallBack()} style={{width:'40%',height:35,backgroundColor:'#019FB2',borderRadius:5,justifyContent:'center',alignItems:'center'}}>
                                <AppText style={{fontSize:16,fontWeight:'500',color:'black'}}>אישור</AppText>
                            </TouchableOpacity>

                        </View>
                    </View>
                </View>


            </Modal>
        )
    }
}

